/**
 * PublishService - publish / roll / share settings (CLOUD_SYNC_SPEC.md §7)
 */
import { API_BASE } from './config.js';

export class PublishService {
    /** @param {import('./CloudClient.js').CloudClient} client */
    constructor(client) {
        this.client = client;
    }

    /** Current publish state for the dialog ({published:false} if none) */
    getState(designId) {
        return this.client.get(`/publish/${designId}`);
    }

    /**
     * Publish (or roll) a design snapshot.
     * @param {string} designId
     * @param {{visibility, allow_edit, title, description, sourceVersion?, handle?}} opts
     */
    publish(designId, opts) {
        return this.client.post(`/publish/${designId}`, opts);
    }

    updateShare(pubId, opts) {
        return this.client.patch(`/publish/${pubId}`, opts);
    }

    unpublish(pubId) {
        return this.client.delete(`/publish/${pubId}`);
    }

    /** Public share URL for a publish state/result */
    shareUrl({ slug, visibility, link_token }) {
        // Served by the API for now; the sketchchair.cc viewer page can
        // take over later without changing stored data (slug is the key)
        const url = new URL(`${API_BASE}/d/${slug}`);
        if (visibility === 'link' && link_token) {
            url.searchParams.set('k', link_token);
        }
        return url.toString();
    }

    /** Public library feed (no auth) */
    library(offset = 0) {
        return this.client.get(`/library?offset=${offset}`);
    }

    /** Open a public share (no auth needed) */
    openShared(slug, token = null) {
        return this.client.get(`/d/${slug}${token ? `?k=${token}` : ''}`);
    }
}
